import * as APP_CONSTANTS from './Constants';
import { TripleDES, enc, mode } from 'crypto-js';
import { MessageBarType } from '@fluentui/react';

export const encryptDataWithTripleDES = theInput => {
	//Encrypt data

	let _strEncryptedParams = TripleDES.encrypt(
		theInput.toString(),
		enc.Utf8.parse(APP_CONSTANTS.CMIC_KEYS.SERVER_SETTINGS_ENCRYPTION_KEY),
		{
			iv: enc.Utf8.parse(APP_CONSTANTS.CMIC_KEYS.SERVER_SETTINGS_ENCRYPTION_VECTOR),
			mode: mode.CBC,
		},
	).toString();

	return _strEncryptedParams;
};

export const encodeDataWithBase64 = theInput => {
	const _objEncodedWord = enc.Utf8.parse(theInput.toString());
	const _strEncryptedParams = enc.Base64.stringify(_objEncodedWord);

	return _strEncryptedParams;
};

export const getUsernameAndTenantId = (_strTenantID, _strUsername) => {
	let _strUsernameForEncryption = '';
	_strUsernameForEncryption =
		_strTenantID == '' || _strTenantID == undefined ? _strUsername : _strTenantID + '||' + _strUsername;

	return _strUsernameForEncryption;
};

export const getEnvironmentNameFromWSURL = _strServerURL => {
	const _strHttpsTag = '://';
	const _strMSPluginTag = 'MSPluginWebService';
	let _strEnvironmentName = _strServerURL;

	let _nStarIndex = -1;
	let _nEndIndex = -1;

	_nStarIndex = _strServerURL.toString().includes(_strHttpsTag) ? _strServerURL.indexOf(_strHttpsTag) : 0;
	_nEndIndex = _strServerURL.toString().includes(_strMSPluginTag)
		? _strServerURL.indexOf(_strMSPluginTag)
		: _strServerURL.length - 1;

	_strEnvironmentName =
		_nStarIndex > -1 && _nEndIndex > -1 && _nStarIndex != _nEndIndex
			? _strServerURL.toString().substr(_nStarIndex, _nEndIndex - _nStarIndex)
			: _strServerURL;

	return _strEnvironmentName;
};

export const createAPIURLWithParams = (_strBaseURL, _strAPIName, objMap) => {
	let _strAPIURL = '';
	let _strInputParams = '';

	//  Create Query String Params
	objMap.forEach((value, key, map) => {
		_strInputParams += key + '=' + value + '&';
	});

	//  Encrypt Query String Params
	_strInputParams = encryptDataWithTripleDES(
		_strInputParams,
		APP_CONSTANTS.CMIC_KEYS.SERVER_SETTINGS_ENCRYPTION_KEY,
		APP_CONSTANTS.CMIC_KEYS.SERVER_SETTINGS_ENCRYPTION_VECTOR,
	);

	//  Encode Query String Params
	_strInputParams = encodeDataWithBase64(_strInputParams);

	// _strAPIURL += _strBaseURL +'/'+_strAPIName + "?param=" + _strInputParams;

	_strAPIURL += '/cmicdevv12/MSPluginWebService/resources/MSPluginWS/';

	_strAPIURL += _strAPIName + '?param=' + _strInputParams;

	return _strAPIURL;
};

export const checkExtraSlashAPIURL = url => {
	while (url.endsWith('/')) {
		url = url.slice(0, -1);
	}
	return url;
};

export const isJSONObjectEmpty = obj => {
	return JSON.stringify(obj) === '{}';
};

export const formatBytes = (bytes, decimals = 0) => {
	if (bytes === '' || bytes === 'undefined') {
		return '0 Bytes';
	}

	if (bytes === 0) {
		return '0 Bytes';
	}
	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
	const i = Math.floor(Math.log(bytes) / Math.log(k));
	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const showCheckBoxForMultipleSelectRowsDataGrid = type => {
	switch (type) {
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_TYPE:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT_TYPE:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT_REVISION:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_REVISION:
			return true;
		default:
			return false;
	}
};

export const checkParentAddittion = nodeType => {
	switch (nodeType) {
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_REVISION:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT_REVISION:
			return true;

		default:
			return false;
	}
};

export const handleBreadCrumbsAddittion = (id, label, breadcrumbs) => {
	if (id === APP_CONSTANTS.CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENTS_PARENT) return [];
	const brdCrmbs = [...breadcrumbs];
	const breadIndex = brdCrmbs.findIndex(e => e.id === id);

	if (breadIndex === -1) {
		brdCrmbs.push({
			id,
			label,
		});
	} else {
		brdCrmbs[breadIndex] = {
			id,
			label,
		};
	}

	return brdCrmbs;
};

export const handleAddOnType = nodeType => {
	switch (nodeType) {
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_ISSUE:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_RFI:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_COMMUNICATION:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_TYPE:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_COMMUNICATION:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_DAILY_JOURNAL:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_ISSUE:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENTS:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT_TYPE:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_PCI:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_RFI:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_SUBCONTRACTORS:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_SUBCONTRACTORS_CHANGE_ORDERS:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_SUBMITTALS:
			return true;

		default:
			return false;
	}
};

export const handlePageSize = nodeType => {
	switch (nodeType) {
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_COMMUNICATION:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_DAILY_JOURNAL:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_ISSUE:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENTS:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_PCI:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_RFI:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_SUBCONTRACTORS:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_SUBCONTRACTORS_CHANGE_ORDERS:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_SUBMITTALS:
			return APP_CONSTANTS.DOC_PAGE_LIMIT;

		default:
			return APP_CONSTANTS.PAGE_LIMIT;
	}
};

export const renewProjList = (list = [], data = {}) => {
	const isProjPresent = list.find(e => e.value === data.value);

	if (isProjPresent) {
		return list;
	} else {
		if (list.length >= 10) {
			list.pop();
		}

		list.push(data);
		return list;
	}
};

export const checkNoneInlineAttachmentCount = attachments => {
	if (attachments?.length) return true;
	else return false;
};

export const handleLoginUserViaAuth2 = userInfo => {
	if (userInfo?.isCloudUser || userInfo?.isEnterpriseOAuth) {
		return {
			headers: {
				Authorization: `Bearer ${userInfo?.accessToken}`,
			},
		};
	} else {
		return {
			auth: {
				username: userInfo.username,
				password: userInfo.password,
			},
		};
	}
};

// handling assets folder path for "cmicpublish" env.

export const handleImagePathForDifferentEnv = () => {
	const windowPathname = window.location.pathname;
	if (windowPathname === '/taskpane.html') {
		return '../../../assets/';
	} else {
		const pathName = window.location.pathname.replace('/taskpane.html', '');
		return `../../..${pathName}/assets/`;
	}
};

// Date format configured for DatePicker (for display only)

export const formatDate = date => {
	if (!date) return '';
	const day = date.getDate().toString().padStart(2, '0');
	const month = date.toLocaleString('default', { month: 'short' });
	const year = date.getFullYear();
	return `${month} ${day}, ${year}`;
};

export const handleAuth2RedirectUri = () => {
	const windowPathname = window.location.pathname;
	if (windowPathname === '/taskpane.html') {
		return `${window.location.origin}`;
	} else {
		const pathName = window.location.pathname.replace('/taskpane.html', '');
		return `${window.location.origin + pathName}`;
	}
};

export const handleDynamicEnvironmentURL = () => {
	let serverLocationPath = window.location.pathname;

	if (serverLocationPath.includes('/cmicprod/outlookplugin/')) {
		return APP_CONSTANTS.CMIC_PROD_ENV_CLOUD;
	} else if (serverLocationPath.includes('/cmictest/outlookplugin/')) {
		return [...APP_CONSTANTS.CMIC_TEST_ENV_CLOUD, ...APP_CONSTANTS.CMIC_PROD_ENV_CLOUD];
	} else if (serverLocationPath.includes('/cmicdev/outlookplugin/')) {
		return [...APP_CONSTANTS.CMIC_TEST_ENV_CLOUD, ...APP_CONSTANTS.CMIC_PROD_ENV_CLOUD];
	} else {
		return [...APP_CONSTANTS.CMIC_TEST_ENV_CLOUD, ...APP_CONSTANTS.CMIC_PROD_ENV_CLOUD];
	}
};

export const isInternetAvailable = setShowToast => {
	if (!navigator.onLine) {
		setShowToast({
			isVisible: true,
			msg: 'No internet',
			type: MessageBarType.error,
		});
	}

	return navigator.onLine;
};

export const isLocalDevelopment = () => window.location.hostname === 'localhost';

export const removeEmojis = text => {
	const emojiPattern =
		/[\u{1F300}-\u{1F9FF}\u{2700}-\u{27BF}\u{1F000}-\u{1F02F}\u{1F0A0}-\u{1F0FF}\u{1F100}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F900}-\u{1F9FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu;

	return text.replace(emojiPattern, '');
};

const RECENT_URLS_KEY = 'recentServerURLs';

export const addRecentServerURL = url => {
	if (!url) return;
	let urls = getRecentServerURLs();
	urls = urls.filter(u => u !== url);
	urls.unshift(url);
	urls = urls.slice(0, 4);
	localStorage.setItem(RECENT_URLS_KEY, JSON.stringify(urls));
}

export const getRecentServerURLs = () => {
	const urls = localStorage.getItem(RECENT_URLS_KEY);
	return urls ? JSON.parse(urls) : [];
}